import { EnvironmentType } from '../app/shared/model/local/config/environment-type';
import { LanguageVersion } from '../app/shared/model/local/config/language-version';

export const environment = {
  type: EnvironmentType.DEV,
  apiUrl: 'https://api.visera-dev-v2.apzumi.dev/api/store',
  production: false,
  defaultLanguage: LanguageVersion.EN,
  recaptchaToken: '6LcPmnMrAAAAAA6S7JzNpDOQRjPs47R59HS4IpG3',
  chargify: {
    publicKey: 'chjs_gqxmcrcrh75jsf9rt76xm8r8',
    serverHost: 'https://sb-visera.chargify.com',
  },
  gaId: '',
};
